import { useState, type CSSProperties } from "react";
import styles from "./LogoImage.module.css";
import { apiUrl as getApiUrl } from "../lib/runtimeConfig";

const LOGO_PLACEHOLDER = "/assets/placeholder-logo.png";

type LogoImageProps = {
  src: string;
  dataUrl?: string;
  alt?: string;
  maxHeight?: number;
  maxWidth?: number;
  className?: string;
};

const toStaticLogoUrl = (val: string): string => {
  const apiUrl = getApiUrl();
  if (!val) return LOGO_PLACEHOLDER;
  if (/^https?:\/\//i.test(val)) return val;
  if (val.startsWith("/files/") || val.startsWith("/images/")) return `${apiUrl}${val}`;
  return `${apiUrl}/files/logo/${val}`;
};

const LogoImage = ({ src, dataUrl, alt = "logo", maxHeight = 50, maxWidth = 150, className }: LogoImageProps) => {
  const [hasError, setHasError] = useState(false);
  const finalSrc = dataUrl && dataUrl.startsWith("data:") ? dataUrl : hasError || !src ? LOGO_PLACEHOLDER : toStaticLogoUrl(src);
  const style = {
    "--logo-image-radius": `${Math.min(maxWidth / 10, 8)}px`,
    "--logo-image-max-height": `${maxHeight}px`,
    "--logo-image-max-width": `${maxWidth}px`,
  } as CSSProperties;

  return (
    <img
      alt={alt}
      className={[styles.image, className].filter(Boolean).join(" ")}
      crossOrigin='anonymous'
      onError={() => setHasError(true)}
      src={finalSrc}
      style={style}
    />
  );
};

export default LogoImage;
